//Wholesaler Data
// export const preprocessData = (data, type = "day") => {
//   const result = [];

//   if (!Array.isArray(data?.data)) return result;

//   data.data.forEach((item) => {
//     const name =
//       item?.name || `${item?.first_name || ""} ${item?.last_name || ""}`.trim();
//     const address = item?.address || "N/A";

//     if (type === "day") {
//       const dayWiseReport = Array.isArray(item.dayWiseReport)
//         ? item.dayWiseReport
//         : [];

//       const totalTransactions = dayWiseReport.reduce(
//         (sum, report) => sum + (report.transactions || 0),
//         0
//       );
//       const totalBottlesSold = dayWiseReport.reduce(
//         (sum, report) => sum + (report.bottlesSold || 0),
//         0
//       );

//       result.push({
//         id: item.id,
//         Name: name,
//         Address: address,
//         Email: item.email,
//         PhoneNo: item.contact,
//         totalTransactions: totalTransactions,
//         totalBottlesSold: totalBottlesSold,
//         dayWiseReport: dayWiseReport,
//         originalItem: item,
//         dataType: "day",
//       });
//     }

//     // Process month-wise reports
//     if (type === "month" && Array.isArray(item.totalTransactionsMonth)) {
//       item.totalTransactionsMonth.forEach((monthItem, i) => {
//         result.push({
//           id: `${item.id}-month-${i + 1}`,
//           Name: name,
//           Address: address,
//           Email: item.email,
//           PhoneNo: item.contact,
//           month: monthItem?.month || "N/A",
//           monthlyTransactions: monthItem?.monthlyTransactions || 0,
//           dataType: "month",
//           originalItem: item,
//         });
//       });
//     }

//     // Process week-wise reports
//     if (type === "week" && Array.isArray(item.totalTransactionsWeek)) {
//       item.totalTransactionsWeek.forEach((weekItem, i) => {
//         result.push({
//           id: `${item.id}-week-${i + 1}`,
//           Name: name,
//           Address: address,
//           Email: item.email,
//           PhoneNo: item.contact,
//           week: weekItem?.week?.toString() || "N/A",
//           weeklyTransactions: weekItem?.weeklyTransactions || 0,
//           dataType: "week",
//           originalItem: item,
//         });
//       });
//     }
//   });

//   return result;
// };

//Wholesaler data
export const preprocessData = (data) => {
  const result = [];

  if (!Array.isArray(data?.data)) return result;

  const formatWeek = (weekStr) => {
    if (!weekStr || weekStr.length < 6) return weekStr;
    return `${weekStr.slice(4)}-${weekStr.slice(0, 4)}`;
  };

  data.data.forEach((item) => {
    const name =
      item?.name || `${item?.first_name || ""} ${item?.last_name || ""}`.trim();
    const address = item?.address || "N/A";

    // Day-wise
    if (Array.isArray(item.dayWiseReport)) {
      const totalTransactions = item.dayWiseReport.reduce(
        (sum, report) => sum + (report.transactions || 0),
        0
      );
      const totalBottlesSold = item.dayWiseReport.reduce(
        (sum, report) => sum + (report.bottlesSold || 0),
        0
      );

      result.push({
        id: item.id,
        Name: name,
        Address: address,
        Email: item.email,
        PhoneNo: item.contact,
        totalTransactions,
        totalBottlesSold,
        dayWiseReport: item.dayWiseReport,
        originalItem: item,
        dataType: "day",
      });
    }

    // Month-wise
    if (Array.isArray(item.totalTransactionsMonth)) {
      result.push({
        id: `${item.id}-month`,
        Name: name,
        Address: address,
        Email: item.email,
        PhoneNo: item.contact,
        monthWiseReport: item.totalTransactionsMonth.map((m) => ({
          month: m?.month || "N/A",
          monthlyTransactions: m?.monthlyTransactions || 0,
        })),
        originalItem: item,
        dataType: "month",
      });
    }

    // Week-wise
    if (Array.isArray(item.totalTransactionsWeek)) {
      result.push({
        id: `${item.id}-week`,
        Name: name,
        Address: address,
        Email: item.email,
        PhoneNo: item.contact,
        weekWiseReport: item.totalTransactionsWeek.map((w) => ({
          week: formatWeek(w?.week?.toString()),
          weeklyTransactions: w?.weeklyTransactions || 0,
        })),
        originalItem: item,
        dataType: "week",
      });
    }
  });

  return result;
};

//BarData
export const preprocessBarData = (response) => {
  let barArray = [];

  if (response?.data?.data?.bars) {
    barArray = response.data.data.bars;
  } else if (response?.data?.bars) {
    barArray = response.data.bars;
  } else if (Array.isArray(response)) {
    barArray = response;
  }

  if (!Array.isArray(barArray)) return [];

  const result = [];

  barArray.forEach((item) => {
    const name = item?.name || item?.first_name || "N/A";
    const address = item?.address || "N/A";
    const regNo = item?.reg_no || "N/A";
    const email = item?.email || "N/A";
    const contact = item?.contact || "N/A";

    // Process day-wise reports
    if (Array.isArray(item.dayWiseReport) && item.dayWiseReport.length > 0) {
      const totalShotsSold = item.dayWiseReport.reduce(
        (sum, report) => sum + (Number(report.totalShots) || 0),
        0
      );

      const brandCounts = {};
      item.dayWiseReport.forEach((report) => {
        if (report.mostOrderedBrand && report.mostOrderedBrand !== "N/A") {
          brandCounts[report.mostOrderedBrand] =
            (brandCounts[report.mostOrderedBrand] || 0) + 1;
        }
      });

      const mostSoldBrand =
        Object.keys(brandCounts).length > 0
          ? Object.keys(brandCounts).reduce((a, b) =>
              brandCounts[a] > brandCounts[b] ? a : b
            )
          : "N/A";

      result.push({
        id: item.id,
        Name: name,
        Address: address,
        RegNo: regNo,
        Email: email,
        Contact: contact,
        totalShotsSold,
        MostSoldBrand: mostSoldBrand,
        dayWiseReport: item.dayWiseReport,
        originalItem: item,
        dataType: "day",
      });
    }

    // Process week-wise reports
    else if (
      Array.isArray(item.weekWiseReport) &&
      item.weekWiseReport.length > 0
    ) {
      const totalShotsSold = item.weekWiseReport.reduce(
        (sum, report) => sum + (Number(report.totalShots) || 0),
        0
      );

      const brandCounts = {};
      item.weekWiseReport.forEach((report) => {
        if (report.mostOrderedBrand && report.mostOrderedBrand !== "N/A") {
          brandCounts[report.mostOrderedBrand] =
            (brandCounts[report.mostOrderedBrand] || 0) + 1;
        }
      });

      const mostSoldBrand =
        Object.keys(brandCounts).length > 0
          ? Object.keys(brandCounts).reduce((a, b) =>
              brandCounts[a] > brandCounts[b] ? a : b
            )
          : "N/A";

      result.push({
        id: item.id,
        Name: name,
        Address: address,
        RegNo: regNo,
        Email: email,
        Contact: contact,
        totalShotsSold,
        MostSoldBrand: mostSoldBrand,
        weekWiseReport: item.weekWiseReport,
        originalItem: item,
        dataType: "week",
      });
    }

    // Process month-wise reports
    else if (
      Array.isArray(item.monthWiseReport) &&
      item.monthWiseReport.length > 0
    ) {
      const totalShotsSold = item.monthWiseReport.reduce(
        (sum, report) => sum + (Number(report.totalShots) || 0),
        0
      );

      const brandCounts = {};
      item.monthWiseReport.forEach((report) => {
        if (report.mostOrderedBrand && report.mostOrderedBrand !== "N/A") {
          brandCounts[report.mostOrderedBrand] =
            (brandCounts[report.mostOrderedBrand] || 0) + 1;
        }
      });

      const mostSoldBrand =
        Object.keys(brandCounts).length > 0
          ? Object.keys(brandCounts).reduce((a, b) =>
              brandCounts[a] > brandCounts[b] ? a : b
            )
          : "N/A";

      result.push({
        id: item.id,
        Name: name,
        Address: address,
        RegNo: regNo,
        Email: email,
        Contact: contact,
        totalShotsSold,
        MostSoldBrand: mostSoldBrand,
        monthWiseReport: item.monthWiseReport,
        originalItem: item,
        dataType: "month",
      });
    }

    // If no reports
    else {
      result.push({
        id: item?.id || `bar-${Math.random()}`,
        Name: name,
        Address: address,
        RegNo: regNo,
        Email: email,
        Contact: contact,
        totalShotsSold: 0,
        MostSoldBrand: "N/A",
        originalItem: item,
        dataType: "day",
      });
    }
  });

  return result;
};

//customer
export const preprocessCustomerData = (response) => {
  const ordersArray = response?.data || [];
  if (!Array.isArray(ordersArray)) return [];

  const result = [];

  ordersArray.forEach((order) => {
    const customer = order.Customer;
    const customerId = customer?.id;
    if (!customerId) return;

    const customerName = `${customer.first_name || ""} ${
      customer.last_name || ""
    }`.trim();
    const orderItems = order.orderItems || [];

    if (orderItems.length > 0) {
      orderItems.forEach((orderItem, itemIndex) => {
        const orderRow = {
          id: `${customerId}-order-${order.id}-item-${itemIndex}`,
          parentId: customerId,
          name: customerName,
          email: customer.email || "N/A",
          mobile: customer.phone || "N/A",
          orderBrand: orderItem.brand_name || "N/A",
          ordered: orderItem.qty || "N/A",
          total: orderItem.total || order.sub_total || 0,
          wholesaler_name:
            orderItem.WholeSaler?.name ||
            orderItem.WholeSaler?.first_name ||
            "N/A",
          date: order.created_at
            ? new Date(order.created_at).toLocaleDateString()
            : "N/A",
          isChild: true,
          dataType: "order",
          orderId: order.id,
          orderNo: order.order_no,
        };

        result.push(orderRow);
      });
    } else {
      const orderRow = {
        id: `${customerId}-order-${order.id}`,
        parentId: customerId,
        name: customerName,
        email: customer.email || "N/A",
        mobile: customer.phone || "N/A",
        orderBrand: "N/A",
        ordered: order.total_qty || "N/A",
        total: order.sub_total || 0,
        wholesaler_name: "N/A",
        date: order.created_at
          ? new Date(order.created_at).toLocaleDateString()
          : "N/A",
        isChild: true,
        dataType: "order",
        orderId: order.id,
        orderNo: order.order_no,
      };

      result.push(orderRow);
    }
  });

  return result;
};

// metrics
export const calculateSalesMetrics = (data, category) => {
  if (category === "Bar/Club") {
    const totalShots = data.reduce((acc, row) => acc + (row.ShotsSold || 0), 0);
    const avgShotsPerDay = data.length > 0 ? totalShots / data.length : 0;
    return { totalSales: totalShots, avgSalesPerDay: avgShotsPerDay };
  } else {
    const totalTransactions = data.reduce(
      (acc, row) => acc + (row.Transactions || 0),
      0
    );
    const avgTransactionsPerDay =
      data.length > 0 ? totalTransactions / data.length : 0;
    return {
      totalSales: totalTransactions,
      avgSalesPerDay: avgTransactionsPerDay,
    };
  }
};

export const calculateCustomerSalesMetrics = (data) => {
  const totalOrders = data.reduce((acc, row) => acc + (row.ordered || 0), 0);
  const avgOrdersPerDay = data.length > 0 ? totalOrders / data.length : 0;
  return { totalSales: totalOrders, avgSalesPerDay: avgOrdersPerDay };
};
